module.exports = __webpack_public_path__ + "img/logo.2fd5d3b6.png";